import {DocumentTemplate} from '../types/documentTemplate';
import {DocumentTemplateRow} from '../types/documentTemplateRow';
import {DocumentTemplateColumn} from '../types/documentTemplateColumn';

const buildDocumentTemplateSnapshot = (
  documentTemplates: DocumentTemplate[],
  templateId: string | undefined,
  elementValues: Record<string, string>,
  fillOutOnCreationValues?: Record<string, any>,
): any | undefined => {
  const selectedTemplate = documentTemplates.find(
    (template: DocumentTemplate) => template.id === templateId,
  );
  if (!selectedTemplate) return undefined;

  const snapshot = {
    ...selectedTemplate,
    rows: selectedTemplate.rows?.map((row: DocumentTemplateRow) => ({
      ...row,
      columns: Object.values(row.columns).map(
        (column: DocumentTemplateColumn) => {
          if (column.element) {
            let updatedElement: any = { ...column.element };
            
            // Handle TextBlock elements with tags
            if (column.element.elementType === 'TextBlock') {
              let content = column.element.properties.content || '';
              Object.entries(elementValues).forEach(([tagName, value]) => {
                const regex = new RegExp(
                  `<span[^>]*tagvalue="\\{${tagName}\\}"[^>]*>.*?<\\/span>`,
                  'g',
                );
                content = content.replace(regex, value);
              });
              updatedElement = {
                ...updatedElement,
                properties: {
                  ...updatedElement.properties,
                  content,
                },
              };
            }
            
            // Handle elements with fillOutOnCreation
            if (fillOutOnCreationValues && (column.element.properties as any)?.fillOutOnCreation) {
              const elementValue = fillOutOnCreationValues[column.element.id];
              if (elementValue !== undefined) {
                updatedElement = {
                  ...updatedElement,
                  properties: {
                    ...updatedElement.properties,
                    value: elementValue,
                  },
                };
              }
            }
            
            return {
              ...column,
              element: updatedElement,
            };
          }
          return column;
        },
      ),
    })),
  };

  return snapshot;
};

export default buildDocumentTemplateSnapshot;
